import { useTranslation } from 'react-i18next';
import { Modal } from '../UI';
import { Button } from '../UI/base/Button';
import styles from './ErrorDialog.module.css';

interface ErrorDialogProps {
  title?: string;
  message: string;
  onClose: () => void;
}

export const ErrorDialog = ({ title, message, onClose }: ErrorDialogProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={title ?? t('error-dialog-title')}
      onClose={onClose}
      width={480}
      footer={
        <Button type="primary" onClick={onClose}>
          {t('error-dialog-close')}
        </Button>
      }
    >
      {/* The dialog appears without warning and always reports a failure, so the message
          is announced at once rather than waiting for the user to reach it. */}
      <p className={styles.modalMessage} role="alert">
        {message}
      </p>
    </Modal>
  );
};
